import axiosClient from "utils/axios";
import { ApiOptionList, ApiResponse } from "../../../types/api.types";
import {
  AddProductRequest,
  Product,
  GetProductsParams,
  GetProductsResponse,
  UpdateProductRequest,
} from "features/Products/types/product.types";

function buildGetProductsParams(input: GetProductsParams) {
  const {
    page,
    limit,
    search,
    categoryId,
    productTypeId,
    materialId,
    uomId,
    isActive,
    brand,
    manufacturer,
  } = input;

  const params: Record<string, string | number | boolean> = {};
  if (page != null) params.page = page;
  if (limit != null) params.limit = limit;
  const q = search?.trim();
  if (q) params.search = q;
  if (categoryId != null && categoryId > 0) params.categoryId = categoryId;
  if (productTypeId != null && productTypeId > 0)
    params.productTypeId = productTypeId;
  if (materialId != null && materialId > 0) params.materialId = materialId;
  if (uomId != null && uomId > 0) params.uomId = uomId;
  if (typeof isActive === "boolean") params.isActive = isActive;
  const b = brand?.trim();
  if (b) params.brand = b;
  const m = manufacturer?.trim();
  if (m) params.manufacturer = m;
  return params;
}

export const getProducts = async (input: GetProductsParams = {}) => {
  try {
    const response = await axiosClient.get<ApiResponse<GetProductsResponse>>(
      "/products",
      {
        params: buildGetProductsParams(input),
      },
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching products : ", err);
    throw err;
  }
};

export const getProductOptions = async ({
  query,
  limit,
  page,
}: {
  query?: string;
  limit?: number;
  page?: number;
}) => {
  try {
    const response = await axiosClient.get<ApiResponse<ApiOptionList>>(
      `/products/options`,
      {
        params: {
          query,
          limit,
          page,
        },
      },
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching Product Options : ", err);
    throw err;
  }
};

export const createProduct = async (payload: FormData) => {
  try {
    const response = await axiosClient.post<ApiResponse<AddProductRequest>>(
      "/products",
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (err) {
    console.warn("Error creating product : ", err);
    throw err;
  }
};

export const updateProduct = async (id: number, payload: FormData) => {
  try {
    const response = await axiosClient.put<ApiResponse<UpdateProductRequest>>(
      `/products/${id}`,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (err) {
    console.warn("Error updating product : ", err);
    throw err;
  }
};

export const getProduct = async (id: number) => {
  try {
    if (!Number.isInteger(id) || id <= 0) {
      throw new Error("Invalid ID");
    }
    const response = await axiosClient.get<ApiResponse<Product>>(
      `/products/${id}`,
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching product : ", err);
    throw err;
  }
};

export const deleteProduct = async (id: number) => {
  try {
    const response = await axiosClient.delete<ApiResponse<Product>>(
      `/products/${id}`,
    );
    return response.data;
  } catch (err) {
    console.warn("Error deleting product : ", err);
    throw err;
  }
};
